import React, { useState, useEffect } from 'react';
import {connect} from "react-redux"
import {purchaseTicket} from "../../actions/piano"
import OfferDisplayStatusConst from "../../common/variables/OfferDisplayStatusConst";
import ProgramStateConst from "../../common/variables/ProgramStateConst";
import {getTaxPrice, getTaxFromSettings, dateTimePrint} from '../../common/methods/CommonUtil';
import { useTranslation,Trans } from "react-i18next";


function OfferSpOnlyPurchaseButtonAndInfo(props) {
    const { t } = useTranslation();
    const [tax, setTax] = useState(1)

    let liveDate = new Date(props.purchase_end_time)
    let archiveDate = new Date(props.archive_purchase_end_time)

    useEffect (() => {
        getTax();
    },)

    const getTax = () => {
		if (!props.settingJson) {return;}
		let tax = getTaxFromSettings(props.settingJson);
		if (tax) {setTax(tax);}
	}

    return (
        <>
            {getButtonSpSwitch(props,t)}
			{ !props.is_ensemble_cancelled?
				(
                    props.display_status === OfferDisplayStatusConst.archive ?
                        <dl className="purchase-info sp-only before-live-only">
                            <dt className="purchase-info__title">{t('offer.price')}</dt>
                            <dd className="purchase-info__text">
                                {getTaxPrice(props.isJapan,props.archivePianoPrice, tax)}{t('offer.yen')}
                            </dd>
                            <dt className="purchase-info__title">{t('offer.purchasedPeriod')}</dt>
                            <dd className="purchase-info__text">{dateTimePrint(props.language, archiveDate , "MMDD/")}</dd>
                        </dl>
                    :
                        <>
                        <dl className="purchase-info sp-only before-live-only">
                            <dt className="purchase-info__title">{t('offer.price')}</dt>
                            <dd className="purchase-info__text" style={{ verticalAlign:'top' }}>
                                {getTaxPrice(props.isJapan , props.pianoPrice, tax)}{t('offer.yen')}
                                <br/>
                            </dd>
                            <dt className="purchase-info__title">{t('offer.purchasedPeriod')}</dt>
                            <dd className="purchase-info__text">{dateTimePrint(props.language, liveDate , "MMDD/")}</dd>
                        </dl>
                        </>
				) : (
					<dl className="purchase-info sp-only before-live-only">
						<dt className="detail-info__title sp-only before-live-only">{t('offer.price')}</dt>
						<dd className="detail-info__text sp-only before-live-only">{t('ticketStatus.cancelled')}</dd>
						<br/><br/>
					</dl>
				)
			}
        </>
    )
}

function getButtonSpSwitch(props,t) {
    let notice = t('offer.notice');
    if (props.isLocationNG){
        return getButtonSP(props, t('ticketStatus.nonPurchasableArea'),true, notice)
    }
    switch (props.programState) {
        case ProgramStateConst.purchased:
            return getButtonSP(props, t('ticketStatus.purchased'), true, notice)
        case ProgramStateConst.streaming:
            return "" // 何も表示しない
        case ProgramStateConst.done:
            return ""  // 何も表示しない
        case ProgramStateConst.waitSale:
            return getButtonSP(props, t('ticketStatus.beforeSalesStart'), true, notice)
        case ProgramStateConst.unavailable:
            return getButtonSP(props, t('ticketStatus.endOfSales'), true, notice)
        case ProgramStateConst.onSale:
            return getButtonSP(props, t('ticketStatus.purchaseTicket'), false, notice)
        default:
            return ""
    }
}

function getButtonSP(props, body, isInvalidation, notice) {
    // 購入不可
    if (isInvalidation) {
        return (
            <>
            <dt className="detail-info__title before-live-only detail-header__date sp-only" style={{ textAlign: 'center' }}>{notice}</dt>
            <div
                className="detail-side__buy-button sp-only before-live-only"
                title={body}
                style={{cursor: "default"}}
            >{body}</div>
            </>
        )
    } else {
        // 購入可
        return (
            <>
            <dt className="detail-info__title before-live-only detail-header__date sp-only" style={{ textAlign: 'center' }}>{notice}</dt>
            <a
                className="detail-side__buy-button sp-only before-live-only"
                title={body}
                onClick={() => {
                    props.purchaseTicket(props.offerId)
                }}
            >{body}</a>
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    purchaseTicket: (offerId) => dispatch(purchaseTicket(offerId)),
})

export default connect(null, mapDispatchToProps)(OfferSpOnlyPurchaseButtonAndInfo)
